/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hwaccel_TitleInputs */

const en_hwaccel_title = /** @type {(inputs: Hwaccel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited performance detected`)
};

const fr_hwaccel_title = /** @type {(inputs: Hwaccel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performances limitées détectées`)
};

const ms_sg2_hwaccel_title = /** @type {(inputs: Hwaccel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasi terhad dikesan`)
};

/**
* | output |
* | --- |
* | "Limited performance detected" |
*
* @param {Hwaccel_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const hwaccel_title = /** @type {((inputs?: Hwaccel_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hwaccel_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hwaccel_title(inputs)
	if (locale === "fr") return fr_hwaccel_title(inputs)
	return ms_sg2_hwaccel_title(inputs)
});